import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const PaymentAppointmentForm = () => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        location_id: "",
        year: "",
        month: "",
        contact: "",
        remark: null,
        due_date: new Date().toISOString().slice(0, 10),
    })
    const {location_id, year, month, contact, remark, due_date} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state) {
            const {payload} = location.state
            setFormData((prev) => ({
                ...prev,
                location_id: payload.location_id,
                year: payload.year,
                month: payload.month,
                contact: payload.contact,
            }))
        }
    },[])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault();

        const payload = {location_id, year, month, contact, remark, due_date}
        saveAppointment(payload)
    }
    
    const saveAppointment = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/appointments/', payload)
            toast.success(response.data?.detail)
            navigate('/daily-appointments')
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Appointment Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Contact"
                                name="contact"
                                type="text"
                                label="Contact"
                                value={contact}
                                onChange={onChange}
                                error={errors.contact}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="due_date"
                                type="date"
                                label="Due Date"
                                value={due_date}
                                onChange={onChange}
                                error={errors.due_date}
                                max={null}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="remark"
                                type="text"
                                label="Remark (Optional)"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Appointment" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default PaymentAppointmentForm
